<template>
    <div>
        <div v-if="room && subscribed">

            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-2">
                        </div>

                        <div class="col-8">
                            <h1 class="header__title">Knockout game</h1>
                        </div>

                        <div class="col-2 text--right">
                            <button type="button" @click="confirmClose" class="btn btn--icon btn--white">
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <section class="container animated fadeIn">
                <div class="row">
                    <div class="col-12 mb--xl">
                        <div class="mb--lg">
                            <div class="panel bg--layer-dark mb--md">
                                <div class="room__list">
                                    <div class="room__list__item">
                                        <div class="profile profile--inline profile--horizontal profile--sm">
                                            <figure class="profile__avatar"><span class="profile__avatar__img"><img
                                                :src="user.avatar" alt=""></span></figure>
                                            <div class="profile__text">
                                                <div class="profile__name"><span>{{ room.name }}</span>
                                                    <div class="locked" v-if="room.is_locked">
                                                        <img src="/img/icons/locked-outline.svg"
                                                             alt="Locked Room">
                                                    </div>
                                                </div>
                                                <div class="game__info weight--normal">
                                                    <div>
                                                        <img v-bind:src="room.game_type_icon" v-bind:alt="room.type" />
                                                        <span>Level {{ room.level }} / {{ questionGroupName }}</span>
                                                    </div>
                                                    <div class="number-of-employees text--right"><img
                                                        src="/img/icons/user-orange.svg" alt=""> <span
                                                        v-if="members">{{ members.length }} <template
                                                        v-if="room.number_of_participants">/ {{
                                                            room.number_of_participants
                                                        }}</template></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="pt--20 pb--30 panel bg--layer-light mb--md">
                                <div class="row">
                                    <div class="col-8 mx--auto text--center"><h4
                                        class="text--md text--uppercase opacity--md weight--normal">SHARE ROOM</h4>
                                        <div class="h1 mb--20">{{ room.id }}</div>
                                        <div class="row">
                                            <div class="col-6">
                                                <button type="button" class="btn btn--block btn--sm btn--white"
                                                        @click="setClipboard(roomURL())">Copy code
                                                </button>
                                            </div>
                                            <div class="col-6">
                                                <button @click="showFriends = true" type="button" class="btn btn--block btn--sm btn--white">Invite
                                                    friends
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="pt--20 pb--30 panel bg--layer-light mb--md" v-show="showFriends">
                                <invite :channel-id="room.id"></invite>
                            </div>

                        </div>
                        <div v-show="startable" class="text--center text--lg weight--bold">
                            Waiting for room owner to start the game!
                        </div>

                        <button
                            type="button"
                            class="btn btn--block btn--primary mt--10"
                            :disabled="! startable"
                            @click="startGame()"
                            v-if="room.creator_id === user.id"
                        >Start game
                        </button>
                    </div>
                    <div class="col-12 mb--lg">
                        <div class="game__statistics"><h2 class="postbox__title text--center">Statistics</h2>
                            <div class="mb--md">

                                <ul role="tablist" class="game__statistics--menu panel bg--layer-light row">
                                    <li class="col-6 text--center">
                                        <a id="games-tab" data-toggle="tab" @click.prevent="currentTab='games'" role="tab"
                                           aria-controls="games"
                                           :class="['btn btn--block btn--tab', {'active': currentTab === 'games'}]"><span>Games</span></a>
                                    </li>
                                    <li class="col-6 text--center">
                                        <a id="users-tab" data-toggle="tab" @click.prevent="currentTab='users'" role="tab"
                                           aria-controls="users" aria-selected="false"
                                           :class="['btn btn--block btn--tab btn--users', {'active': currentTab === 'users'}]"><span>Users</span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="game__statistics--content">
                                    <div id="games" role="tabpanel" aria-labelledby="games-tab" class="tab-pane" v-show="currentTab === 'games'">
                                        <select class="form-control mb--md" v-if="roundList" v-model="selectedRound">
                                            <option :value="round" v-for="round in roundList">Round {{ round }} result</option>
                                        </select>
                                        <div class="tab-pane--result">
                                            <div class="game__ready">
                                                <div class="row pt--20 pb--20  opacity--sm">
                                                    <div class="col-12 text--center"><span>Ready</span></div>
                                                </div>
                                                <matches-table :matches="finishedMatches"></matches-table>
                                            </div>
                                            <div class="in_progress">
                                                <div class="row pt--20 pb--20 opacity--sm">
                                                    <div class="col-12 text--center"><span>In progress</span></div>
                                                </div>
                                                <matches-table :matches="inProgressMatches"></matches-table>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="users" role="tabpanel" aria-labelledby="users-tab"
                                         class="tab-pane panel bg--layer-light" v-show="currentTab === 'users'">
                                        <div class="tab-pane--result">
                                            <div class="game__users" v-if="members">
                                                <div class="row" v-for="member in members">
                                                    <div class="col-6 ">
                                                        <div class="player">
                                                            <div class="profile profile--inline profile--horizontal">
                                                                <figure class="profile__avatar"><span
                                                                    class="profile__avatar__img"><img
                                                                    :src="member.avatar" alt=""></span></figure>
                                                                <div class="profile__text weight--bold">{{ member.nick }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 text--right">
                                                        <div>Level {{ member.level }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <modal ref="confirmCloseModal" show="false" type="error">
                <template v-slot:title>
                    Exit game
                </template>

                <template v-slot:message>
                    Are you sure?
                </template>

                <template v-slot:buttons>
                    <button type="button" @click="closeGame" class="btn btn--block btn--green mb--10">Yes</button>
                    <button type="button" @click="hideConfirmAlert" class="btn btn--block btn--white">No</button>
                </template>
            </modal>
        </div>
        <room-is-full v-if="roomIsFull"></room-is-full>
    </div>

</template>

<script>
import MatchesTable from "../SimpleGroupGame/partial/MatchesTable";
import RoomIsFull from "../partial/RoomIsFull";
import {mapGetters} from "vuex";

export default {
    components: {MatchesTable, RoomIsFull},

    props: ['matches', 'room'],

    data: function () {
        return {
            subscribed: false,
            showFriends: false,
            members: null,
            selectedRound: 1,
            currentTab: 'users',
            startInProgress: false,
            roomIsFull: false
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user'
        ]),

        startable() {
            if (this.room.has_knockout_table) {
                return false
            }

            if (this.members && this.members.length === this.room.number_of_participants && !this.startInProgress) {
                return true
            }

            return false
        },

        questionGroupName() {
            return get(this.room.questionGroup, 'name', 'All categories')
        },

        roundList() {
            return this.matches.unique('round').pluck('round').sort()
        },

        finishedMatches() {
            return this.matches.filter((item) => ['finished', 'disconnected'].includes(item.status) && item.round === this.selectedRound)
        },

        inProgressMatches() {
            return this.matches.filter((item) => item.status === 'in_progress'  && item.round === this.selectedRound)
        }
    },

    methods: {
        confirmClose() {
            this.$refs.confirmCloseModal.open()
        },

        closeGame() {
            this.hideConfirmAlert()
            this.$router.push('/')
        },

        hideConfirmAlert() {
            this.$refs.confirmCloseModal.close()
        },

        roomURL() {
            let route = this.$router.resolve({
                name: 'findKnockoutGame',
                params: {code: this.room.id},
            })

            return window.app_url + route.href
        },

        startGame() {

            if (this.startInProgress) {
                return
            }

            this.startInProgress = true

            if (!this.members || this.members.length !== this.room.number_of_participants) {
                alert('There are not enough players to start a game. Please try again later.')
                this.startInProgress = false
                return
            }

            this.send({
                event: "start",
                data: {
                    channel: 'knockout-' + this.room.id,
                }
            });
        }
    },

    created() {
        this.subscribe('knockout-' + this.room.id)

        Quiz.$on('pusher_internal:subscription_succeeded', (message) => {
            if (message.channel === 'knockout-' + this.room.id) {
                this.roomIsFull = false
                this.subscribed = true
            }
        })

        Quiz.$on('channelMembers', (message) => {
            if (message.data.channel === 'knockout-' + this.room.id) {
                this.members = message.data.members
            }
        })

        Quiz.$on('notEnoughPlayers', (message) => {
            if (message.data.channel === 'knockout-' + this.room.id) {
                this.startInProgress = false
                alert('There are not enough players to start the knockout game!')
            }
        })

        Quiz.$on('channelIsFull', (message) => {
            if (message.data.channel === 'knockout-' + this.room.id) {
                this.roomIsFull = true
            }
        })

    },

    beforeDestroy() {
        Quiz.$off('channelMembers')
        Quiz.$off('channelIsFull')
        Quiz.$off('notEnoughPlayers')
        Quiz.$off('pusher_internal:subscription_succeeded')
    }
}
</script>
